<template>
    <div v-show="isWinAspect">
        <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
        <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
        <div class="win_bg"></div>
        <div class="win">
            <div class="btn_win_close" @click="close()">[X]</div>
            <div class="win-header">Корпоративный стандарт</div>
            <div class="skill" v-for="skill in skills_aspects_list" :key="skill.id">
                <div class="skill_name"> {{ skill.name }} </div>
                <div class="aspect" v-for="aspect in skill.aspects" :key="aspect.id">
                    {{ aspect.name }}
                    <button :disabled="aspects_in_mk_list[aspect.id]" class="aspect_btn" @click="add_aspect(aspect.id)">Добавить</button>
                    <div class="clear:both"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'Winaspect',
    components: {
        Success, Error
    },
    data() {
        return { 
            skills_aspects_list: {},
            corpstandart_id: 0,
            mk_list_id: 0,
            isWinAspect: false,
            aspects_in_mk_list: [],
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
        }
    },
    methods: {
        close() {
            this.$emit('close')
            this.isWinAspect = false
        },
        skills_aspects() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/marking_list/all_aspects/'+this.corpstandart_id+'/'+this.mk_list_id)
                .then(response => {
                    this.skills_aspects_list = response.data.data
                    let aspects = response.data.aspect_list_in_mk
                    let resault = [];
                    aspects.forEach(element => {
                        resault[element.aspect_id] = true 
                    });
                    this.aspects_in_mk_list = resault
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
                });
        },
        add_aspect(aspect_id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/marking_list/add_aspect_in_mklist', {
                mklist_id: this.mk_list_id,
                aspect_id: aspect_id
            })
                .then(response => {
                    this.operation_info = response.data.data
                    this.isSuccess = true
                    this.skills_aspects()
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
                });
        }
    }

}
</script>


<style scoped>
    .win_bg {
        display: block;
        position: fixed;
        width: 100% !important;
        height: 100% !important;
        background: #000000;
        opacity: 0.6;
        z-index: 999;
        left: 0px;
        top: 0px;
    }
    .win {
        display: block;
        width: 600px !important;
        min-height: 400px !important;
        position: absolute;
        background: #ffffff;
        left: 50%;
        margin-left: -300px;
        top: 150px;
        z-index: 1000;
        border-radius: 7px;
        box-sizing: border-box;
        padding: 15px;
        margin-bottom: 50px !important;
    }
    .win-header {
        font-size: 20px;
    }
    .btn_win_close {
        display: block;
        position: absolute;
        width: 15px;
        height: 15px;
        cursor: pointer;
        right: 15px;
    }
    .btn_win_close:hover {
        color: blue;
    }
    .skill {
        display: block;
        margin-top: 20px;
    }
    .skill_name {
        display: block;
        background: #E1E7ED;
        border-radius: 10px;
        color: #55759E;
        padding: 7px;
        box-sizing: border-box;
    }
    .aspect {
        display: block;
        margin-top: 20px;
        font-size: 14px;
        width: 100% !important;
        box-sizing: border-box;
        padding-left: 20px;
    }
    .aspect_btn {
        display: block;
        float: right !important;
        cursor: pointer;
    }
</style>